export default "<div *ngIf=\"!isLoading\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n";